import React from 'react';

import ButtonBase from '../Button/ButtonBase';
import Icon from '../Icon/Icon';
import { TIconButton } from './types';

type TIconButtonBase = TIconButton & {
  kind: 'primary' | 'secondary' | 'tertiary' | 'destructive' | 'destructive-ghost';
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IconButtonBase = ({ name, color, ariaLabel, ...rest }: TIconButtonBase) => (
  <ButtonBase {...rest} aria-label={ariaLabel} isIconButton>
    <Icon name={name} />
  </ButtonBase>
);

export default IconButtonBase;
